import { withAuthenticationRequired } from '@auth0/auth0-react'
import { NotFound } from 'modules/NotFound'
import { ComponentProps } from 'react'
import { Route, Routes } from 'react-router'
import { Schedule, ScheduleSuccess } from '../../components/Appointment'
import { ModalPage } from '../../components/layout'
import { AppointmentProvider, SchedulingModeProvider, SchedulingStateProvider } from '../../hooks'

const Success = ({ isReschedule }: ComponentProps<typeof ScheduleSuccess>) => (
  <AppointmentProvider>
    <ScheduleSuccess isReschedule={isReschedule} />
  </AppointmentProvider>
)

const Index = () => (
  <SchedulingStateProvider>
    <SchedulingModeProvider>
      <Schedule />
    </SchedulingModeProvider>
  </SchedulingStateProvider>
)

const ConsultantPage = () => (
  <ModalPage>
    <Routes>
      <Route element={<Index />} path="/" />
      <Route element={<Success />} path=":appointmentId/success" />
      <Route element={<Success isReschedule />} path=":appointmentId/reschedule/success" />
      <Route element={<NotFound />} path="*" />
    </Routes>
  </ModalPage>
)

const AuthenticatedConsultant = withAuthenticationRequired(ConsultantPage)

export { AuthenticatedConsultant as Consultant }
